<template>
  <section
    id="services"
    class="hide-overflow"
  >
    <v-layout accent>
      <v-flex
        hidden-sm-and-down
        md6
      >
        <v-img
          :src="'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2Fdesign.jpg?alt=media&token=14552a93-d1a1-477a-9709-994f5bcba7ce'"
          height="100%"
        />
      </v-flex>
      <v-flex
        xs12
        md6
        text-xs-center
        pa-5
      >
        <v-layout
          align-center
          justify-center
          fill-height
          wrap
        >
          <v-flex xs12>
            <base-bubble-2
              style="transform: translateX(55%)"
            />
            <base-heading class="info--text">
              {{ $t('offer') }}
            </base-heading>

            <base-text class="mb-5">
              {{ $t('proposition') }}
              {{ $t('goodJob') }}
            </base-text>
          </v-flex>
          <v-flex
            v-for="(service, i) in services"
            :key="i"
            md6
            text-xs-center
            mb-3
          >
            <v-avatar
              class="elevation-6 mb-2"
              color="#69A1BB"
              size="64"
              tile
            >
              <v-icon
                dark
                size="52"
                v-text="service.icon"
              />
            </v-avatar>
            <base-text>
              <div
                class="mb-2"
                v-text="service.name"
              />
              <div v-text="service.blurb" />
            </base-text>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import service from '../locales/services'

export default {
  computed: {
    services () {
      switch (this.$store.getters.getLanguage) {
        case 'en': return service.en
        case 'ru': return service.ru
        case 'uk': return service.uk
        default: return service.en
      }
    }
  }
}
</script>
